import { RentInsurance, RentInsuranceDTO } from '../../../../models/RentInsurance';

export const toRentInsurance = (dto: RentInsuranceDTO): RentInsurance => ({
  uuid: dto.uuid,
  status: dto.status,
  projects: (dto.projects ?? []).map(({ cover_months, ...rest }) => ({ ...rest, coverMonths: cover_months })),
  issuanceState: dto.issuanceState
});
